import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user || user === false) {
      setIds([]);
      return;
    }
    try {
      const { data } = await api.get("/favorites/ids");
      setIds(data || []);
    } catch {
      setIds([]);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isFavorite = (id) => ids.includes(id);

  const toggle = async (id) => {
    if (!user || user === false) return { needsLogin: true };
    const wasFav = ids.includes(id);
    // optimistic
    setIds((prev) => wasFav ? prev.filter(x => x !== id) : [...prev, id]);
    try {
      if (wasFav) await api.delete(`/favorites/${id}`);
      else        await api.post(`/favorites/${id}`);
      return { favorited: !wasFav };
    } catch {
      // revert
      setIds((prev) => wasFav ? [...prev, id] : prev.filter(x => x !== id));
      return { error: true };
    }
  };

  return (
    <FavoritesContext.Provider value={{ ids, isFavorite, toggle, refresh }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  return useContext(FavoritesContext);
}
